import { render, staticRenderFns } from "./TextPortraitGlitch.vue?vue&type=template&id=fe1dac20&scoped=true"
import script from "./TextPortraitGlitch.vue?vue&type=script&lang=js"
export * from "./TextPortraitGlitch.vue?vue&type=script&lang=js"
import style0 from "./TextPortraitGlitch.vue?vue&type=style&index=0&id=fe1dac20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1dac20",
  null
  
)

export default component.exports